import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)

let routes = []

const routerContext = require.context('./', true, /index\.js$/)

routerContext.keys().forEach(route => {
  // 如果是根目录的 index.js、 不做任何处理
  if (route.startsWith('./index')) {
    return
  }
  const routerModule = routerContext(route)
  // 兼容 import export 和 require module.export 两种规范  Es modules  commonjs
  routes = [...routes, ...(routerModule.default || routerModule)]
})

routes = [
  {
    path: '/modelEdit',
    name: 'modelEdit',
    component: () => import('../views/modelEdit.vue'),
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/sceneEdit',
    name: 'sceneEdit',
    component: () => import('../views/sceneEdit.vue'),
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/account',
    name: 'account',
    component: () => import('../views/Account.vue'),
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/scenePreview',
    name: 'scenePreview',
    component: () => import('../views/scenePreview.vue'),
    meta: {
      requireAuth: false
    }
  },
  {
    path: '/sceneView',
    name: 'sceneView',
    component: () => import('../views/sceneView.vue'),
    meta: {
      requireAuth: false
    }
  },
  
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/loginWeixin',
    name: 'loginWeixin',
    component: () => import('../views/LoginWeixin.vue')
  },
  {
    path: 'model',
    name: 'model',
    component: () => import('../views/Model.vue')
  },
  {
    path: '/admin',
    name: 'admin',
    component: () => import('../views/Admin.vue'),
    meta: {
      requireAuth: true
    },
    children: [
      {
        path: 'upload',
        name: 'upload',
        component: () => import('../views/Upload.vue'),
      },
      {
        path: 'modelList',
        name: 'modelList',
        component: () => import('../views/ModelList.vue')
      },
    ]
  },
  {
    path: '/',
    name: 'index',
    component: () => import('../views/Index.vue')
  },

  ...routes
]



export default new Router({
  mode: 'history', //发布的时候需要打开
  base:'/dist/', //发布的时候需要打开
  //base: process.env.BASE_URL,
  routes: routes
})